<template>
    <superslide :options="options" class="hot_wrap">
        <div class="txtMarquee-top">
            <div class="bd">
                <ul>
                    <li v-for="(item,index) in registered" :key="index" class="infoList">
                        <p class="hot_img"><img src="../assets/images/hot.png" alt=""></p>
                        <p class="hot_name">{{item.name}}</p>
                        <p class="hot_mobile">{{item.mobile}}</p>
                        <p class="hot_time">{{item.time}}</p>
                    </li>
                </ul>
            </div>
        </div>
    </superslide>
</template>

<script>
    let registered = [
        {
            id: 1,
            name: '张**',
            mobile: '150******07',
            time: '1分钟前'
        },
        {
            id: 2,
            name: '戴*',
            mobile: '156******01',
            time: '1分钟前'
        },
        {
            id: 3,
            name: '李**',
            mobile: '177******31',
            time: '2分钟前'
        },
        {
            id: 5,
            name: '段**',
            mobile: '150******67',
            time: '3分钟前'
        },
        {
            id: 6,
            name: '东*',
            mobile: '191******00',
            time: '3分钟前'
        },
        {
            id: 7,
            name: '张*',
            mobile: '151******77',
            time: '3分钟前'
        },
        {
            id: 8,
            name: '吴*',
            mobile: '155******66',
            time: '4分钟前'
        },
        {
            id: 9,
            name: '李*',
            mobile: '135******51',
            time: '5分钟前'
        },
        {
            id: 10,
            name: '王*',
            mobile: '157******99',
            time: '6分钟前'
        },
    ]
    export default {
        name: "registered",
        data(){
            return{
                registered: registered,
                options: {
                    mainCell: ".bd ul",
                    autoPlay: true,
                    effect: "topMarquee",
                    vis: 2,
                    interTime: 50
                }
            }
        },
    }
</script>

<style scoped lang="less">
.hot_wrap{
    margin: 0 auto;
    width: 88%;
    padding: 3% 5%;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 3px;
    li{
        display: -webkit-box; /* 老版本语法: Safari, iOS, Android browser, older WebKit browsers. */
        display: -moz-box; /* 老版本语法: Firefox (buggy) */
        display: -ms-flexbox; /* 混合版本语法: IE 10 */
        display: -webkit-flex; /* 新版本语法: Chrome 21+ */
        display: flex; /* 新版本语法: Opera 12.1, Firefox 22+ */
        -webkit-box-pack: justify;
        -moz-justify-content: space-around;
        -webkit-justify-content: space-around;
        justify-content: space-around;
        -webkit-box-align: center;
        -moz-align-items: center;
        -webkit-align-items: center;
        align-items: center;
        width: 100%;
        p{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 14px;
        }
        .hot_img{
            width: 10%;
            img{
                width: 55%;
                display: block;
            }
        }
        .hot_name{
            width: 25%;
        }
        .hot_mobile{
            width: 40%;
        }
        .hot_time{
            width: 25%;
        }

    }
}
</style>
